import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuthStore } from '@vanialabs/core-auth';

import { ProtectedRoute } from '../auth/ProtectedRoute';
import { RequirePermission } from '../auth/RequirePermission';
import { AppLayout } from '../layout/AppLayout';
import { LoginPage } from '../pages/LoginPage';

import { DashboardPage } from '../../features/dashboard';
import { CustomersPage } from '../../features/customers';
import { CustomerDetailsPage } from '../../features/customers/CustomerDetailsPage';
import { ServicesPage } from '../../features/services';
import { OrdersPage } from '../../features/orders';
import { WalletPage } from '../../features/wallet';
import { CommissionPage } from '../../features/commission';
import { SupportPage } from '../../features/support';
import { SettingsPage } from '../../features/settings';


export function AppRouter() {
  const initialized = useAuthStore(
    (state) => state.isInitialized
  );

  const setInitialized = useAuthStore(
    (state) => state.setInitialized
  );
  if (!initialized) {
    return null;
  }


  return (
    <Routes>

      <Route
        path="/login"
        element={<LoginPage />}
      />


      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >

        <Route
          index
          element={
            <Navigate
              to="/dashboard"
              replace
            />
          }
        />


        <Route
          path="dashboard"
          element={<DashboardPage />}
        />

        <Route
          path="customers"
          element={
        <RequirePermission module="customers" permission="view">
          <CustomersPage />
        </RequirePermission>
      }
        />

        <Route
          path="customers/:id"
          element={
        <RequirePermission module="customers" permission="view">
          <CustomerDetailsPage />
        </RequirePermission>
      }
        />

        <Route
          path="services"
          element={
        <RequirePermission module="services" permission="view">
          <ServicesPage />
        </RequirePermission>
      }
        />

        <Route
          path="orders"
          element={
        <RequirePermission module="orders" permission="view">
          <OrdersPage />
        </RequirePermission>
      }
        />

        <Route
          path="wallet"
          element={
        <RequirePermission module="wallet" permission="view">
          <WalletPage />
        </RequirePermission>
      }
        />

        <Route
          path="commission"
          element={
        <RequirePermission module="commission" permission="view">
          <CommissionPage />
        </RequirePermission>
      }
        />

        <Route
          path="support"
          element={
        <RequirePermission module="support" permission="view">
          <SupportPage />
        </RequirePermission>
      }
        />

        <Route
          path="settings"
          element={<SettingsPage />}
        />

      </Route>


      <Route
        path="*"
        element={
          <Navigate
            to="/dashboard"
            replace
          />
        }
      />

    </Routes>
  );
}
